module.exports = __webpack_public_path__ + "static/media/collection-bird-12.0b4e367b.png";